var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPrintingTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00033 13.667C10.6803 13.667 13.667 10.6803 13.667 7.00033C13.667 3.32032 10.6803 0.333658 7.00033 0.333658C3.32033 0.333657 0.333659 3.32032 0.333659 7.00032C0.333658 10.6803 3.32032 13.667 7.00033 13.667ZM7.66699 3.66699L7.66699 5.00032L6.33366 5.00032L6.33366 3.66699L7.66699 3.66699ZM7.66699 10.3337L7.66699 6.33366L6.33366 6.33366L6.33366 10.3337L7.66699 10.3337Z",
    fill: "#5A87EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPrintingTip);
export default __webpack_public_path__ + "static/media/jobconfig-printing-tip.5d986f3f71e829eb24720e8de7c75831.svg";
export { ForwardRef as ReactComponent };